import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./inventaryForm.data.form";
import InputDate from "../../../utils/InputDate";

const InventaryForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onback } = props;

  return (
    <>
      <div className="row justify-content-center mt-md-0">
        <div className="col-12 col-md-11">
          <h3 className="title">{t("forms.inventary.titleCancelEdit")}</h3>
        </div>
      </div>
      {/* <BreadCrumb items={breads} /> */}
      <div className="row justify-content-center mt-2">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="dateInit"
                  labelField={t("forms.inventary.labels.dateInit")}
                  className="form-control"
                  name="dateInit"
                  component={InputDate}
                  language="es"
                  dateFormat="dd/MM/yyyy"
                  mandatory
                  showTimeSelect
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback("ModalForm")}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.inventary.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.inventary.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

InventaryForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const InventaryFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ServiceForm",
})(InventaryForm);

export default InventaryFormF;
